import React from 'react'
import { useTranslation } from 'react-i18next';
function Video() {
    const { t } = useTranslation();
    return(
    <section className="knsl-p-0-100">
        <div className="container">
            <div className="knsl-about-card">
                <div className="row g-0">
                    <div className="col-lg-6">
                        <div className="knsl-about-text">
                            <div className="knsl-title-frame">
                            <h2 className="knsl-mb-20">{t('main.aboutTitle2')}</h2>
                            <p className="knsl-mb-30">{t('main.aboutDesc2')}</p>
                            <a data-fancybox href="https://www.youtube.com/watch?v=wsq-r8lMMsk" className="knsl-btn knsl-btn-md"><img src="assets/img/icons/play.svg" alt="icon" className="knsl-zoom" />Watch video</a>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="knsl-video-frame">
                            <img src="assets/img/about/8.jpg" alt="cover" />
                            <a data-fancybox href="https://www.youtube.com/watch?v=wsq-r8lMMsk" className="knsl-play-btn">
                                <i className="fas fa-play"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    )   
}

export default Video as React.FC